import { getCarinhaPosition } from '../../utils/Positions';
import carinhas from '../carinhas';
import { Coordinate } from '../../model';
import './carinhas.css';

interface CarinhasProps {
  coord: Coordinate;
}

const Carinhas: React.FC<CarinhasProps> = ({ coord }) => {
  return (
    <>
      {carinhas.map(carinha => {
        if (!carinha.src) return null;

        const posC = getCarinhaPosition(coord, carinha);

        return (
          <img
            key={carinha.key}
            alt={carinha.key}
            className="carinha"
            src={carinha.src}
            style={{
              top: `calc(50% + ${posC.top}px)`,
              left: `calc(50% - ${posC.left}px)`,
            }}
          />
        );
      })}
    </>
  );
}

export default Carinhas;
